var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.072.609a2.224 2.224 0 0 0-.506.334C10.14 1.31.823 9.981.823 10.01c0 .029 9.318 8.701 9.743 9.067.357.308.641.423 1.047.423.561 0 1.048-.289 1.324-.787.119-.215.128-.263.128-.686 0-.398-.013-.482-.106-.664a2.12 2.12 0 0 0-.304-.411A303.006 303.006 0 0 0 9.821 14.3l-2.637-2.448 8.682-.022c8.059-.02 8.696-.027 8.867-.096.625-.251.971-.754.976-1.421.003-.266-.019-.373-.119-.595a1.704 1.704 0 0 0-.721-.755l-.191-.101-9.096-.022-9.097-.022 3.008-2.793a303.731 303.731 0 0 0 3.187-2.982c.315-.335.385-.527.385-1.05 0-.423-.009-.471-.128-.686-.167-.302-.488-.586-.786-.698-.312-.117-.78-.117-1.079 0",
    fillRule: "evenodd",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.d52642c961c1a5719a6d08ad7e80bfce.svg";
export { ForwardRef as ReactComponent };